module.exports = __webpack_public_path__ + "img/siwei_teacher-qrcode.24739414.png";